import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
// /*
//     便捷操作cookie
//     key [string] 键值
//     value [string|number|object] 值
//     attributes [object]
//      - expires 数字,单位天
//         可通过toGMTString() | toUTCString()转换成GMT格式的时间；
//         若为空则是会话cookie，这种cookie在浏览器关闭后就清除了
//      - max-age 同expires，数字,单位秒，ie不支持
//      - domain 域名
//         可设置为当前域名(默认)或当前域名的父域
//      - path 路径
//         默认当前页面的path
//      - secure 安全
//         设置cookie只在确保安全的请求中才会发送，如HTTPS.只有在当前网页是https协议时，才能设置
//         默认为空
//      - httpOnly 标识js是够能获取
//         使用在node端，client端无法设置该属性
// "key=name; expires=Thu, 26 Feb 2016 04:18:00 GMT;
// domain=qiyukf.com; path=/; secure; httpOnly"
// */

var isDate = function isDate(v) {
  return Object.prototype.toString.call(v) === '[object Date]';
};
var Cookie = {
  set: function set(key, value, option) {
    if (option === void 0) {
      option = {};
    }
    var nval = value;
    var nkey = key;
    var opts = _extends({
      path: '/'
    }, option);
    var expires = opts.expires;
    if (typeof expires === 'number') {
      expires = new Date(new Date().getTime() + expires * 864e5); // Date 格式
    }
    // 默认会话期
    opts.expires = isDate(expires) ? expires.toUTCString() : expires || '';
    // 如果是字符串
    if (typeof value === 'string') {
      nval = encodeURIComponent(nval);
      nkey = encodeURIComponent(nkey);
    } else {
      try {
        var tres = JSON.stringify(nval);
        if (/^[\{\[]/.test(tres)) {
          nval = tres;
        }
      } catch (e) {
        // console.log(e);
      }
      nval = encodeURIComponent(String(nval)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
      nkey = encodeURIComponent(String(nkey)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
    }
    // 设置attr
    var attr = '';
    Object.keys(opts).forEach(function (item) {
      if (opts[item]) {
        attr += "; " + item;
        // boolean不需要处理,如secure
        if (opts[item] !== true) {
          attr += "=" + opts[item].split(';')[0];
        }
      }
    });
    document.cookie = nkey + "=" + nval + attr;
  },
  get: function get(key) {
    var res = {};
    var decode = function decode(s) {
      return s.replace(/(%[0-9A-Z]{2})+/g, function (arg) {
        var str = arg;
        try {
          str = decodeURIComponent(arg);
        } catch (e) {
          // console.log(e);
        }
        return str;
      });
    };
    // cookie为空
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    for (var n = 0, len = cookies.length; n < len; n += 1) {
      var parts = cookies[n].split('=');
      var cookie = parts.slice(1).join('=');
      if (cookie.charAt(0) === '"') {
        cookie = cookie.slice(1, -1);
      }
      var name = decode(parts[0]);
      cookie = decode(cookie);
      res[name] = cookie;
      if (key === name) {
        break;
      }
    }
    var result = key ? res[key] : res;
    return typeof result !== 'undefined' ? result : '';
  },
  getJSON: function getJSON(key) {
    var val = Cookie.get(key);
    try {
      return JSON.parse(val);
    } catch (e) {
      return e.message || '';
    }
  },
  remove: function remove(key, option) {
    if (option === void 0) {
      option = {};
    }
    Cookie.set(key, '', _extends({
      expires: -1
    }, option));
  }
};
export default Cookie;